import { Injectable } from "@angular/core";
import { PriceAlert } from "@models";
import { DesktopNotifyService } from "./desktop.notify.service";
import { FiatService } from "@main-services/currency";
import { TranslationService } from "@core-services/translation.service";
import { InfoService } from "@core-services/info.service";
import { TradableListService } from "../currency/tradable_list.service";
import { Metal } from "@models/asset/metal/metal";
import { Router } from "@angular/router";
import { PathResolverService } from "@main-services/path-resolver.service";

@Injectable({
	providedIn: "root"
})
export class PriceAlertNotifyService extends DesktopNotifyService<PriceAlert> {
	protected NOTIFICATION_ID: string = "2";

	public constructor(
		private tradableListService: TradableListService,
		protected translationService: TranslationService,
		protected infoService: InfoService,
		private fiatService: FiatService,
		public router: Router,
		private readonly pathResolverService: PathResolverService
	) {
		super(router);
	}

	protected send(action: string, priceAlert: PriceAlert): void {
		let data: string;
		let text = ""; // Panda Price Alert 🐼
		const currency = this.tradableListService.getItemById(priceAlert.getCurrencyId());
		const currencySymbol = currency.getSymbol();
		const currencyName = currency.getName();

		let tradable_amount = "1 " + currencyName;
		const symbol_fiat_amount =
			this.fiatService.getItemById(priceAlert.getFiatId()).getSymbolCharacter() + " " + priceAlert.getAmount();
		const tag = "Bitpanda_pricealert_" + action + "_" + priceAlert.getId();

		if (this.tradableListService.getItemById(priceAlert.getCurrencyId()) instanceof Metal) {
			tradable_amount = "1" + currencySymbol + " " + currencyName;
			data = currencyName.toLowerCase();
		} else {
			data = currencySymbol.toLowerCase();
		}

		text =
			this.translationService.translate("pricealert") +
			": " +
			this.translationService.translate(priceAlert.getVerb(), [tradable_amount, symbol_fiat_amount]);

		if (text.length > 0) {
			this.desktopNotificationPrice("Bitpanda", {
				body: text,
				tag: tag,
				time: priceAlert.getTime(),
				data: data,
				url: this.pathResolverService.assetDetails(currency)
			});
		}
	}
}
